const NAVIGATION_EVENT = 'palen-browser-navigation';
const TRACKING_STARTED_KEY = '__palenBrowserPageViewTrackingStarted';
const INITIAL_PAGE_VIEW_DELAY_MS = 3_000;

type TrackingWindow = Window & {
  [TRACKING_STARTED_KEY]?: boolean;
};

export function startBrowserPageViewTracking(
  onPageView: () => void = trackBrowserPageView,
  deferInitialPageView = false,
): void {
  if (typeof window === 'undefined') {
    return;
  }

  const trackingWindow = window as TrackingWindow;
  if (trackingWindow[TRACKING_STARTED_KEY]) {
    return;
  }

  trackingWindow[TRACKING_STARTED_KEY] = true;
  if (deferInitialPageView) {
    window.setTimeout(onPageView, INITIAL_PAGE_VIEW_DELAY_MS);
  } else {
    onPageView();
  }
  window.addEventListener('popstate', onPageView);
  window.addEventListener(NAVIGATION_EVENT, onPageView);
  patchHistoryNavigation();
}

function patchHistoryNavigation(): void {
  (['pushState', 'replaceState'] as const).forEach((method) => {
    const original = window.history[method];
    window.history[method] = function (...args: Parameters<History[typeof method]>) {
	  const previousUrl = window.location.href;
      const result = original.apply(this, args);
	  if (window.location.href !== previousUrl) {
		window.dispatchEvent(new Event(NAVIGATION_EVENT));
	  }
      return result;
    };
  });
}

function trackBrowserPageView(): void {
  void import('./index').then(({ analyticsService }) => {
    analyticsService.capturePageView({ source: 'browser_navigation' });
  });
}
